import { SVGInterface } from "../../interface";

const ChatFilled = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M16.6665 2.5H3.33317C2.4165 2.5 1.67484 3.25 1.67484 4.16667L1.6665 19.1667L4.99984 15.8333H16.6665C17.5832 15.8333 18.3332 15.0833 18.3332 14.1667V4.16667C18.3332 3.25 17.5832 2.5 16.6665 2.5ZM7.49984 10H5.83317V8.33333H7.49984V10ZM10.8332 10H9.1665V8.33333H10.8332V10ZM14.1665 10H12.4998V8.33333H14.1665V10Z"
      fill={color || "black"}
    />
  </svg>
);

export default ChatFilled;
